export const getDashboardUrl = () => {
  if (process.env.REACT_APP_DASHBOARD_URL) {
    return process.env.REACT_APP_DASHBOARD_URL;
  }
  const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  if (isLocal) {
    // If the website is running on port 3000, assume dashboard is on 3001, otherwise assume 3000.
    const port = window.location.port === "3000" ? "3001" : "3000";
    return `http://localhost:${port}`;
  }
  return "https://app.elderlylife.com";
};
